function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.2601 61.3844C9.2601 46.0133 1.29788 35.4578 1.29788 28.0511C1.29788 20.6444 5.55566 5.08887 39.629 5.08887C73.7023 5.08887 78.7023 26.0155 78.7023 34.1622C78.7046 72.3111 9.2601 88.6066 9.2601 61.3844Z",
  fill: "#F7F7F9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.55559 24.4445C3.71782 24.4445 2.22226 22.9489 2.22226 21.1112C2.22226 19.2734 3.71782 17.7778 5.55559 17.7778C7.39337 17.7778 8.88893 19.2734 8.88893 21.1112C8.88893 22.9489 7.39337 24.4445 5.55559 24.4445ZM5.55559 20.0001C4.94448 20.0001 4.44448 20.4978 4.44448 21.1112C4.44448 21.7245 4.94448 22.2223 5.55559 22.2223C6.1667 22.2223 6.6667 21.7245 6.6667 21.1112C6.6667 20.4978 6.1667 20.0001 5.55559 20.0001Z",
  fill: "#A4AFC1"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M60.5556 60.5556H19.4444C16.9889 60.5556 15 58.5667 15 56.1112V22.7778H65V56.1112C65 58.5667 63.0111 60.5556 60.5556 60.5556Z",
  fill: "#F7F7F9"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M65 22.7778H15V19.4444C15 16.9889 16.9889 15 19.4444 15H60.5556C63.0111 15 65 16.9889 65 19.4444V22.7778Z",
  fill: "#E7F5FE"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M55.0001 52.7778C53.1556 52.7778 51.6667 54.2667 51.6667 56.1112V51.6667C51.6667 49.8223 50.1779 48.3334 48.3334 48.3334C46.489 48.3334 45.0001 49.4445 45.0001 49.4445C45.0001 47.6001 43.5112 46.1112 41.6667 46.1112C40.2823 46.1112 39.0979 46.9512 38.5934 48.1512L38.3334 36.1112C38.3334 34.2667 36.8445 32.7778 35.0001 32.7778C33.1556 32.7778 31.6667 34.2667 31.6667 36.1112V58.8445C30.2001 56.8667 27.4223 53.8889 23.889 53.8889C20.5556 53.8889 19.4445 55.0889 19.4445 56.1112C19.4445 58.6667 22.2001 59.6001 25.2445 66.6667H58.3334V56.1112C58.3334 54.2667 56.8445 52.7778 55.0001 52.7778Z",
  fill: "#E7F5FE"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M24.4444 15H19.4444C16.9889 15 15 16.9889 15 19.4444V22.7778H20V19.4444C20 16.9889 21.9889 15 24.4444 15Z",
  fill: "#B6E2FB"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M26.1001 54.2978C25.4001 54.0511 24.6667 53.8889 23.889 53.8889C20.5556 53.8889 19.4445 55.0889 19.4445 56.1111C19.4445 58.6667 22.2001 59.6 25.2445 66.6667H30.2445C27.2001 59.6 24.4445 58.6667 24.4445 56.1111C24.4445 55.4578 24.9045 54.7378 26.1001 54.2978Z",
  fill: "#B6E2FB"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M36.6668 58.8445V36.1112C36.6668 35.2689 36.9868 34.5112 37.5001 33.9245C36.889 33.2267 36.0024 32.7778 35.0001 32.7778C33.1557 32.7778 31.6668 34.2667 31.6668 36.1112V54.5201C33.8713 55.4978 35.6113 57.4223 36.6668 58.8445Z",
  fill: "#B6E2FB"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M20 56.1112V22.7778H15V56.1112C15 58.5667 16.9889 60.5556 19.4444 60.5556H24.4444C21.9889 60.5556 20 58.5667 20 56.1112Z",
  fill: "#E5E5EF"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M66.6665 62.2223H63.3332V19.4445C63.3332 17.9134 62.0865 16.6667 60.5554 16.6667H19.4443C17.9132 16.6667 16.6665 17.9134 16.6665 19.4445V48.8889H13.3332V19.4445C13.3332 16.0734 16.0732 13.3334 19.4443 13.3334H60.5554C63.9265 13.3334 66.6665 16.0734 66.6665 19.4445V62.2223Z",
  fill: "#75768A"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M15 21.1111H65V24.4444H15V21.1111Z",
  fill: "#75768A"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M40.0001 55H36.6668V49.4445C36.6668 46.6867 38.9113 44.4445 41.6668 44.4445C44.4224 44.4445 46.6668 46.6867 46.6668 49.4445V51.6667H43.3335V49.4445C43.3335 48.5245 42.5846 47.7778 41.6668 47.7778C40.749 47.7778 40.0001 48.5245 40.0001 49.4445V55Z",
  fill: "#75768A"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M46.6665 57.2222H43.3332V51.6666C43.3332 48.9088 45.5776 46.6666 48.3332 46.6666C51.0887 46.6666 53.3332 48.9088 53.3332 51.6666V56.1111H49.9999V51.6666C49.9999 50.7466 49.251 50 48.3332 50C47.4154 50 46.6665 50.7466 46.6665 51.6666V57.2222Z",
  fill: "#75768A"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M60 66.6666H56.6667V56.1111C56.6667 55.1911 55.9178 54.4444 55 54.4444C54.0822 54.4444 53.3333 55.1911 53.3333 56.1111V59.4444H50V56.1111C50 53.3533 52.2444 51.1111 55 51.1111C57.7556 51.1111 60 53.3533 60 56.1111V66.6666Z",
  fill: "#75768A"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M23.7155 67.3266C22.2111 63.8355 20.7866 61.9244 19.7444 60.5289C18.6466 59.0555 17.7777 57.8933 17.7777 56.1111C17.7777 55.4622 18.0733 52.2222 23.8889 52.2222C26.2666 52.2222 28.3222 53.26 30 54.6355V36.1111C30 33.3533 32.2444 31.1111 35 31.1111C37.7555 31.1111 40 33.3533 40 36.1111V49.4444H36.6666V36.1111C36.6666 35.1911 35.9177 34.4444 35 34.4444C34.0822 34.4444 33.3333 35.1911 33.3333 36.1111V58.8444C33.3333 59.5644 32.8733 60.2022 32.1889 60.4266C31.5022 60.6511 30.7555 60.4155 30.3266 59.8377C29.1422 58.2377 26.7289 55.5555 23.8889 55.5555C21.5666 55.5555 21.0955 56.1955 21.0933 56.2022C21.1111 56.76 21.4889 57.2911 22.4155 58.5355C23.4911 59.9777 25.1177 62.1555 26.7755 66.0066L23.7155 67.3266Z",
  fill: "#75768A"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M4.44452 64.4445H75.5556V67.7778H4.44452V64.4445Z",
  fill: "#75768A"
});

function SvgRecentVisit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentVisit);
export default __webpack_public_path__ + "static/media/recent-visit.3d407935.svg";
export { ForwardRef as ReactComponent };